import React from 'react'

const GestorDocumental = () => {
  return (
    <div>GestorDocumental</div>
  )
}

export default GestorDocumental